<template>
  <form ref="deviceForm">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label>{{ $t("min-temp") }}</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="minTemperature"
                  required
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label>{{ $t("max-temp") }}</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="maxTemperature"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label>{{ $t("min-humid") }}</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="minHumidity"
                  required
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label>{{ $t("max-humid") }}</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="maxHumidity"
                  required
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group w-100">
            <label>{{ $t("device") }}</label>
            <select
              class="form-control"
              style="height: 50px"
              name="device"
              v-model="device"
              required
            >
              <option
                v-for="device in devices"
                :value="device.id"
                :key="device.id"
              >
                {{ device.settings.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DeviceStep",
  props: {
    initialValues: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(["devices"]),
  },
  data() {
    return {
      device: this.initialValues.device || "",
      minTemperature: this.initialValues.minTemperature || "",
      maxTemperature: this.initialValues.maxTemperature || "",
      minHumidity: this.initialValues.minHumidity || "",
      maxHumidity: this.initialValues.maxHumidity || "",
    };
  },
  methods: {
    validateForm() {
      const form = this.$refs.deviceForm;
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      return true;
    },
    getFormData() {
      return {
        device: this.device,
        minTemperature: this.minTemperature,
        maxTemperature: this.maxTemperature,
        minHumidity: this.minHumidity,
        maxHumidity: this.maxHumidity,
      };
    },
  },
  watch: {
    initialValues: {
      handler(newValues) {
        this.device = newValues.device || "";
        this.minTemperature = newValues.minTemperature || "";
        this.maxTemperature = newValues.maxTemperature || "";
        this.minHumidity = newValues.minHumidity || "";
        this.maxHumidity = newValues.maxHumidity || "";
      },
      deep: true,
    },
  },
};
</script>
